<div *ngIf="!showSignUpProgressDialog" class="setup-container">
  <div class="header">
    <div class="text-title-1">
      Good afternoon, {{(user$ | async)?.firstName}}
    </div>
    <div class="description">
      Take a minute to set things up.
    </div>
  </div>

<!-- TODO: update router links on buttons -->
  <div class="setup-panels">
    <div class="setup-panel">
      <div class="setup-header-container">
        <div class="setup-header">Build Inventory</div>
        <div class="setup-description">
          Start building your inventory so you can record your first transaction.
        </div>
      </div>

      <div class="setup-control">
        <app-button styleClass="settings"
                    subStyle="blue"
                    text="Add Inventory"
                    class="cancel"
                    (clicked)="goToPage('inventory/bulk-add')"
        >
        </app-button>
      </div>
    </div>

    <div *ngIf="adminRoles.includes((currentPharmacy$ | async)?.role)" class="setup-panel">
      <div class="setup-header-container">
        <div class="setup-header">Wholesaler Order Integration</div>
        <div class="setup-description">
          Connect directly to your wholesaler to automatically receive your orders.
        </div>
      </div>

      <div class="setup-control">
        <app-button [minWidth]="0"
                    styleClass="settings"
                    subStyle="blue"
                    text="Setup"
                    class="cancel"
                    (clicked)="goToPage('settings')"
        >
        </app-button>
      </div>
    </div>

    <div *ngIf="adminRoles.includes((currentPharmacy$ | async)?.role) && (currentPharmacy$ | async)?.role !== UserRolesEnum.PharmacyAdmin"
         class="setup-panel"
    >
      <div class="setup-header-container">
        <div class="setup-header">Build Your Team</div>
        <div class="setup-description">
          Add your co-workers and empower them to start using C2 Keep.
        </div>
      </div>

      <div class="setup-control">
        <app-button styleClass="settings"
                    subStyle="blue"
                    text="Add Teammate"
                    class="cancel"
                    (clicked)="goToPage('team')"
        >
        </app-button>
      </div>
    </div>

    <div class="setup-refs">
      <a routerLink="/dashboard" class="label-later animation-focus-default">
        I'll do this later
      </a>
    </div>
  </div>
</div>

<app-dialog-progress
  [progress]="signUpProgress"
  [labels]="signUpProgressSteps"
  [show]="showSignUpProgressDialog"
>
  <app-pharmacy-details
    [currentStep]="pharmacyDetailsStep"
    [location]="PharmacyLocationEnum.Setup"
    (closeForm)="signUpCancel()"
    (submitted)="savePharmacyForm($event)"
    *ngIf="signUpProgress === SignUpProgressEnum.PharmacyDetails"
  ></app-pharmacy-details>
  <app-set-pin-dialog
    [displayToggle]="true"
    (cancel)="signUpProgress = SignUpProgressEnum.PharmacyDetails"
    (afterPinSet)="savePharmacyDetails()"
    [isDisabled]="(loadingPharmacy$ | async) === true"
    *ngIf="signUpProgress === SignUpProgressEnum.SetPIN"
  ></app-set-pin-dialog>
</app-dialog-progress>
